import { render, staticRenderFns } from "./PriTama05_Core.vue?vue&type=template&id=ab9cf810&scoped=true&"
import script from "./PriTama05_Core.vue?vue&type=script&lang=js&"
export * from "./PriTama05_Core.vue?vue&type=script&lang=js&"
import style0 from "./PriTama05_Core.vue?vue&type=style&index=0&id=ab9cf810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9cf810",
  null
  
)

export default component.exports